import axiosInstance from "../../config/axios/axios.config";
import { fetchData } from "../../helpers/api";

export async function fetchIndexToolsData(filters) {
  const { code, reportName, propType, queryParams, token } = filters;

  if (token) {
    queryParams.append("token", token);
  }

  return fetchData({
    endpoint: `widgets/:reportName/:propType/:code/indextools/`,
    params: { reportName, propType, code },
    queryParams,
    errorFlag: "WidgetError",
  });
}

export async function fetchAdditionalData(filters) {
  const { code, report_address, prop_type, customer_id, cbsa_code } = filters;
  let url = "widgets/additional/indexdata/";
  let postData = {
    code: code,
    report_address: report_address,
    prop_type: prop_type,
    customer_id: customer_id,
    cbsa_code: cbsa_code,
  };
  try {
    const response = await axiosInstance.post(url, postData);
    return response.data;
  } catch (error) {
    if (error?.flag === "WidgetError") {
      return null;
    }
    throw new Error(
      `Failed fetch data. fetchAdditionalData with error: ${error}`
    );
  }
}
